module.exports = __webpack_public_path__ + "img/placeholder-image-5040.8ab043c4.jpg";